var _svg;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaybackPlay = ({
  className = '',
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({
  className: `-svg-file-PlaybackPlay Icon ${className}`
}, props), _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#484848",
  fillOpacity: 0.6,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11 11.922c0-1.493 1.69-2.412 3.02-1.646l14.011 8.078a1.883 1.883 0 0 1 0 3.292l-14.01 8.078C12.689 30.49 11 29.571 11 28.078z"
})))));
export default SvgPlaybackPlay;